import { useQuery } from '@tanstack/react-query';

import { getNew } from '../api/ventura/adGroup';
import mapAdGroupToForm from '../util/mapAdGroupToForm';
import { useConfig } from './useConfig';

function useNewAdGroup(lineItemId: number) {
  const { apiHost } = useConfig();

  const newAdGroup = useQuery({
    queryKey: ['campaigns', 'new', lineItemId],
    queryFn: () => getNew(apiHost, lineItemId),
    select: (value) => {
      const adGroup = mapAdGroupToForm(value);
      // Make USA the default device country.
      adGroup.targetingProfile.device_countries = ['USA'];
      return {
        ...adGroup,
        // Override secure to be true by default
        secure: true,
      };
    },
  });

  return newAdGroup;
}

export default useNewAdGroup;
